import dataApi from '../'

export default {

  /**
   * Get currencies
   */
  getAll (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/currency/all',
      params: params
    })
  },
  /**
  * Get all enabled currencies
  */
  getAllEnabled (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/currency/all-enabled',
      params: params
    })
  },
  /**
   * Update currency settings
   */
  update (params) {
    return dataApi.request({
      method: 'put',
      url: 'ui/currency/update',
      body: params
    })
  },

  /**
   * Get currency denominations
   * @param params
   * @returns {Promise | Promise<unknown>}
   */
  getCurrencyDenominations (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/currency/get-currency-denominations',
      params: params
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/currency.js